import { render, staticRenderFns } from "./waitSeal.vue?vue&type=template&id=4fa469cc"
import script from "./waitSeal.vue?vue&type=script&lang=js"
export * from "./waitSeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports